import vehiclesReducer from "./vehiclesReducer"
export default vehiclesReducer